if ( typeof ProductBundler !== 'function' ) {

  class ProductBundler extends HTMLElement {

    constructor() {

      super();

      if ( this.querySelector('css-slider') ) {
        this.querySelector('css-slider').addEventListener('ready', ()=>{
          this.init();
        })
      } else {
        this.init();
      }

    }

    init(){
      // auto selecting the value of the payment method dropdown
      const preselectedPaymentMethod = document.querySelector('.cart__payment-method').innerText;
      if (preselectedPaymentMethod !== '' && preselectedPaymentMethod !== undefined) {
        this.querySelector('#bundle-payment-method').value = document.querySelector('.cart__payment-method').innerText;
      } else {
        document.querySelector('#bundle-payment-method').options[0].selected = true;
      }

      this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];
      this._bundleTemplate = this.querySelector('[data-js-bundler-product]').cloneNode(true);
      this._bundleMin = parseInt(this.dataset.minimum);

      this.querySelectorAll('[data-js-product-add-to-cart]').forEach(elm=>{
        elm.addEventListener('click', e=>{
          e.preventDefault();
          const product = e.target.closest('[data-js-product-item]');
          const id = product.querySelector('.product-form').querySelector('input[name="id"]').value;
          const variant = product.querySelector('product-variants').getVariantData().find(variant=>{
            return variant["id"] == id;
          });
          const purchaseTypeInputs = product.querySelector('.purchase_type_radio').querySelectorAll('input[type="radio"]');
          const selectedPurchaseType = Array.from(purchaseTypeInputs).find(input => input.checked).value;
          const paymentTypeOptions = product.querySelector('.subscription-payment-type').querySelectorAll('option');
          const selectedPaymentType = Array.from(paymentTypeOptions).find((option) => option.selected).dataset.paymentType;
          this.addToBundle(variant, product, selectedPurchaseType, selectedPaymentType);
          this.classList.add('opened');
        });
      });

      this.querySelectorAll('[data-js-bundler-product-remove]').forEach(elm=>{
        elm.addEventListener('click', e=>{
          this.clearSlot(e.target.closest('[data-js-bundler-product]'));
        });
      });
      
      this.querySelector('[data-js-bundler-toggle]').addEventListener('click', e=>{
        if ( window.innerWidth < 768 ) {
          this.classList.toggle('opened');
        }
      });

      this.querySelector('[data-js-add-bundle-to-cart]').addEventListener('click', e=>{
        const selectedPaymentMethod = this.querySelector('#bundle-payment-method').value;
        const isManualPayment = KROWN.settings.manualPaymentTypes.includes(selectedPaymentMethod);
        if ( ! this.findEmptySlot() ) {

          let items = [];
          this.bundleProducts.map(elm=>{
            if ( elm.dataset.id ) {
              if ( ! items.find(item => {
                if ( item.id == elm.dataset.id ) {
                  if ( isManualPayment ) {
                    if ( item.properties._sellingplan == elm.dataset.sellingPlan ) {
                      item.quantity++;
                      return true;
                    }
                  } else {
                    if ( item.selling_plan == elm.dataset.sellingPlan ) {
                      item.quantity++;
                      return true;
                    }
                  }
                }
              }) ) {
                let itemObj = {
                  id: elm.dataset.id,
                  quantity: 1,
                  selling_plan: isManualPayment ? '' : elm.dataset.sellingPlan
                };
                if (isManualPayment) {
                  itemObj.properties = {_sellingplan: elm.dataset.sellingPlan};
                }
                items.push(itemObj);
              }
            }
          })

          if ( items.length > 0 ) {

            const submitButton = this.querySelector('[data-js-add-bundle-to-cart]');
            submitButton.classList.add('working');
            window.handleAddToCart(
              JSON.stringify({
                attributes: { "_paymentMethod": selectedPaymentMethod },
                'items': items
              }),
              items.reduce((total, { quantity }) => total + quantity, 0),
              { 'Content-Type': 'application/json' },
              ()=>{
                submitButton.classList.remove('working');
                this.querySelectorAll('[data-js-bundler-product]').forEach(elm=>{
                  this.clearSlot(elm);
                });
                this.classList.remove('opened');
              }
            );

          }

        }

      });
      this.querySelector("#bundle-payment-method").addEventListener("change", this.cartUpdate.bind(this));
    }

    findEmptySlot() {
      return this.bundleProducts.find(elm=>{
        return elm.classList.contains('bundler-product--empty')
      });
    }
    
    clearSlot(slot) {
      if ( this.bundleProducts.length > this._bundleMin ) {
        this.bundleProducts.splice(this.bundleProducts.indexOf(slot), 1)
        slot.remove();
      } else {
        slot.product.classList.remove('product-item--bundled');
        slot.dataset.id = "";
        slot.product = null;
        slot.classList.add('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = '';
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = '';
      }
      if ( this.findEmptySlot() ) {
        this.classList.remove('bundler-full');
      }
      this.reorderSlots();
    }

    reorderSlots() {
      let ei = 0,
          fi = -100;
      this.querySelectorAll('[data-js-bundler-product]').forEach((elm, i)=>{
        if ( elm.classList.contains('bundler-product--empty') ) {
          elm.style.order = ei++;
        } else {
          elm.style.order = fi++;
        }
      });
    }

    createSlot(){
      const newSlot = this._bundleTemplate.cloneNode(true);
      newSlot.querySelector('[data-js-bundler-product-remove]').addEventListener('click', e=>{
        this.clearSlot(e.target.closest('[data-js-bundler-product]'));
      });
      this.querySelector('[data-js-bundler-products]').appendChild(newSlot);
      this.bundleProducts.push(newSlot);
    }

    addToBundle(variant, product, selectedPurchaseType, selectedPaymentType) {

      let slot = this.findEmptySlot();
      const imageSrc = variant.featured_image ? variant.featured_image.src : product.querySelector('[data-js-quick-buy-product-image]').textContent;

      if ( ! slot && this.hasAttribute('data-limit-maximum') ) {
        this.createSlot();
        slot = this.findEmptySlot();
      } 

      if ( slot ) { 

        slot.classList.remove('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = `
          <span class="bundler-product__text-title text-line-height--medium text-weight--bold">${product.querySelector('[data-js-quick-buy-product-title]').textContent}</span>
          ${ product.querySelector('product-variants').hasAttribute('data-has-variants') ? `<span class="bundler-product__text-variant text-color--opacity">${variant.title}</span>` : '' }
        `;
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = `
          <img src="${this.getResizedImageSrc(imageSrc, 60)}"
            srcset="
              ${this.getResizedImageSrc(imageSrc, 60)} 60w,
              ${this.getResizedImageSrc(imageSrc, 120)} 120w,
              ${this.getResizedImageSrc(imageSrc, 180)} 180w
            "
            sizes="60px"
          />
        `;

        if ( this.hasAttribute('data-limit-bundles') ) {
          product.classList.add('product-item--bundled');
        }
        slot.product = product;
        slot.dataset.id = product.querySelector('input[name="id"]').value;
        slot.dataset.sellingPlan = "";
        slot.dataset.selectedPurchaseType = selectedPurchaseType;
        slot.dataset.selectedPaymentType = selectedPaymentType;
        const selectedSubscriptionRadioValue = product.querySelector('input[type="radio"]:checked').value;
        product.querySelectorAll('div[data-subscription]').forEach(elm => {
          if (elm.getAttribute('value') === slot.dataset.id && selectedSubscriptionRadioValue === "subscription") {
            slot.dataset.sellingPlan = elm.dataset.subscription;
          }
        });

      } else {
        // when bundle is full, show message
      }

      if ( ! this.findEmptySlot() ) {
        this.classList.add('bundler-full');
      }
      
    }

    getResizedImageSrc(src, size, crop='center') {
      return (`${src}${src.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=${crop}`).replace(/\n|\r|\s/g, "");
    }

    // function to call confirmation modal of changing payment method
    cartUpdate () {
      const currentPaymentMethodTypeInCart = document.querySelector(".cart__payment-method").innerHTML;
			const paymentMethodSelected =document.querySelector('.product-payment-method--select').value;
			if (
				!!currentPaymentMethodTypeInCart &&
				currentPaymentMethodTypeInCart !== paymentMethodSelected
			  ) {
				document.getElementById("gocardlessModal").show();
			}
    }
  }

  // changing the payment method to the previously selected one on click of No button in modal
  document.querySelector(".cta-no").addEventListener("click", () => {
    handleCloseAction();
  });

  // changing the payment method to the previously selected one on closing the modal
  document.querySelector("#gocardlessModal .modal-close").addEventListener("click", () => {
    handleCloseAction();
  });

  // calling clear cart api on click of yes in payment method reset in modal
  document.querySelector(".cta-yes").addEventListener("click", () => {
    document.querySelector(".cta-no").classList.add('no-click');
    document.querySelector(".cta-yes").classList.add('no-click');
    document.querySelector(".cta-yes .button-text").classList.add('visibility-hidden');
    document.querySelector(".cta-yes .button-loader-container").classList.remove('visibility-hidden');

    fetch(KROWN.settings.routes.cart_clear_url, {
      method: "POST",
      headers: {
      "Content-Type": "application/json",
      Accept: "application/javascript",
      },
    })
    .then((response) => response.json())
    .then(() => {
      return fetch("?section_id=helper-cart");
    })
    .then((response) => response.text())
    .then((text) => {
      const sectionInnerHTML = new DOMParser().parseFromString(text,"text/html");
      const cartFormInnerHTML = sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
      const cartSubtotalInnerHTML = sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

      const cartItems = document.getElementById("AjaxCartForm");
      cartItems.innerHTML = cartFormInnerHTML;
      cartItems.ajaxifyCartItems();

      document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
        elm.textContent = cartItems.querySelector("[data-cart-count]").textContent;
      });
      document.querySelectorAll("[data-header-cart-total").forEach((elm) => {
        elm.textContent = cartItems.querySelector("[data-cart-total]").textContent;
      });

      document.getElementById("AjaxCartSubtotal").innerHTML = cartSubtotalInnerHTML;

      const event = new Event("cart-updated");
      this.dispatchEvent(event);
    })
    .then(() => {
      document.getElementById("gocardlessModal").hide();

      document.querySelector(".cta-no").classList.remove('no-click');
      document.querySelector(".cta-yes").classList.remove('no-click');
      document.querySelector(".cta-yes .button-text").classList.remove('visibility-hidden');
      document.querySelector(".cta-yes .button-loader-container").classList.add('visibility-hidden');
    })
    .catch((e) => {
      console.log(e);
    });
  });

  // changing the payment method to the previously selected one
  handleCloseAction = () => {
    const paymentMethodType = document.querySelector(".cart__payment-method").innerHTML;
    const selectedOption = document.querySelector(".product-payment-method--select");
    selectedOption.value = KROWN.settings.manualPaymentTypes.includes(paymentMethodType) ? paymentMethodType : selectedOption?.options[0]?.value;
  }

  if ( typeof customElements.get('product-bundler') == 'undefined' ) {
    customElements.define('product-bundler', ProductBundler);
  }

}